import { Temporal } from "@js-temporal/polyfill";

/**
 * The Temporal polyfill dropped its second-precision accessors in 0.5. Stored
 * schedule times are whole seconds, so these keep the call sites reading in the
 * unit the data is in.
 */
export const instantFromEpochSeconds = (seconds: number): Temporal.Instant =>
  Temporal.Instant.fromEpochMilliseconds(seconds * 1000);

/**
 * Dividing `epochMilliseconds` by 1000 is not a
 * substitute on its own: it keeps the sub-second remainder, and a fractional
 * value written to a protobuf int64 field such as `Timestamp.seconds` throws
 * when that field is later parsed with `BigInt`.
 */
export const epochSecondsOf = (value: { epochMilliseconds: number }): number =>
  Math.floor(value.epochMilliseconds / 1000);
